import { Trans, useTranslation } from 'react-i18next';
import { Box, Card, CardHeader, Typography } from '@material-ui/core';
import React, { useState } from 'react';

import { RailzButton } from '@railzai/railz-uikit-react';

import useStyle from './style';
import PasswordForm from './password';

import { Header, View } from 'components';

interface Props {
  testid: string;
}

export const Security: React.FC<Props> = ({
  testid = 'test-header-security-page',
}): React.ReactElement => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState<string | false>();

  const classes = useStyle();

  const handleChange = (panel: string): void => {
    if (panel !== expanded) {
      setExpanded(panel);
    } else {
      setExpanded(false);
    }
  };

  const titles = {
    password: <div>{t('DASHBOARD_SECURITY_PASSWORD_HEADER')}</div>,
  };

  return (
    <>
      <Header
        drawerMenu={true}
        title={t('DASHBOARD_SECURITY_HEADER')}
        leftComponent={null}
        rightComponent={null}
        testId={testid}
      />
      <View>
        <Card className={classes.container}>
          <Box>
            <CardHeader
              className={classes.cardHeader}
              title={titles.password}
              action={
                <ButtonToggle
                  description={t('DASHBOARD_SECURITY_PASSWORD_CTA')}
                  onClick={handleChange}
                  isFor="password"
                  ariaLabel={t('DASHBOARD_SECURITY_PASSWORD_PURPOSE')}
                />
              }
              subheader={
                <Box data-testid="change-password-subheader">
                  <Typography
                    variant="subtitle1"
                    paragraph={true}
                    className={classes.noMarginBottom}
                  >
                    {<Trans i18nKey="DASHBOARD_SECURITY_PASSWORD_PURPOSE" />}
                  </Typography>
                </Box>
              }
            />
            {expanded === 'password' && <PasswordForm onClose={(): void => setExpanded(null)} />}
          </Box>
        </Card>
      </View>
    </>
  );
};

const ButtonToggle = ({
  description,
  onClick,
  isFor,
  ariaLabel,
  disabled = false,
}): React.ReactElement => {
  return (
    <RailzButton
      type="outlined"
      data-testid={`btn-${isFor}`}
      label={description}
      isDisabled={disabled}
      onButtonClick={(): void => onClick(isFor)}
      aria-label={ariaLabel}
    />
  );
};
